"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const ko = __importStar(require("knockout"));
var FroalaEditor = require('froala-editor/js/froala_editor.pkgd.min');
(function () {
    'use strict';
    // locals
    var unwrap = ko.utils.unwrapObservable;
    var editorInstance = null;
    /**
     * initiate froala editor, listen to its changes
     * and updates the underlying observable model
     *
     * @param {element} element
     * @param {object} value
     * @param {object} bindings
     * @api public
     */
    function init(element, value, bindings) {
        var model = value();
        var allBindings = unwrap(bindings());
        var options = ko.toJS(allBindings.froalaOptions);
        // register events before initializing the editor
        for (var eventName in allBindings.froalaEvents) {
            $(element).on('froalaEditor.' + eventName, allBindings.froalaEvents[eventName]);
        }
        // initialize the editor
        // provide froala editor instance for flexibility
        if (allBindings.froalaInstance && ko.isWriteableObservable(allBindings.froalaInstance)) {
            allBindings.froalaInstance($(element).data('froala.editor'));
        }
        // update underlying model whenever editor content changed
        var processUpdateEvent = function (e) {
            if (ko.isWriteableObservable(model)) {
                //if froalaInstance defined, use that for the editor instance
                if (allBindings.froalaInstance && ko.isWriteableObservable(allBindings.froalaInstance)) {
                    editorInstance = allBindings.froalaInstance();
                }
                if (editorInstance != null) {
                    var editorValue = editorInstance.html.get();
                    editorValue = editorValue.replace('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>', '');
                    var current = model();
                    if (current !== editorValue) {
                        model(editorValue);
                    }
                }
            }
        };
        options.events = {
            initialized: function () {
                editorInstance = this;
                // provide froala editor instance for flexibility
                if (allBindings.froalaInstance && ko.isWriteableObservable(allBindings.froalaInstance)) {
                    allBindings.froalaInstance(editorInstance);
                }
            },
            'contentChanged': processUpdateEvent,
            'paste.after': processUpdateEvent
        };
        new FroalaEditor(element, options || {});
        // cleanup editor, when dom node is removed
        ko.utils.domNodeDisposal.addDisposeCallback(element, destroy(element, bindings));
        // do not handle child nodes
        return { controlsDescendantBindings: true };
    }
    /**
     * update froala editor whenever underlying observable model
     * is updated
     *
     * @param {element} element
     * @param {object} value
     * @api public
     */
    function update(element, value, bindings) {
        var modelValue = unwrap(value());
        //if froalaInstance defined, use that for the editor instance
        var allBindings = unwrap(bindings());
        if (allBindings.froalaInstance && ko.isWriteableObservable(allBindings.froalaInstance)) {
            editorInstance = allBindings.froalaInstance();
        }
        if (editorInstance == null) {
            return;
        }
        var editorValue = editorInstance.html.get();
        // avoid any un-necessary updates
        if (editorValue !== modelValue && (typeof modelValue === 'string' || modelValue === null)) {
            editorInstance.html.set(modelValue);
        }
    }
    /**
     * destroy froala editor instance
     *
     * @param {dom} element
     * @return {function} handler
     * @api private
     */
    function destroy(element, bindings) {
        return function () {
            //if froalaInstance defined, use that for the editor instance
            var allBindings = unwrap(bindings());
            if (allBindings.froalaInstance && ko.isWriteableObservable(allBindings.froalaInstance)) {
                editorInstance = allBindings.froalaInstance();
            }
            if (editorInstance != null) {
                editorInstance.destroy();
            }
        };
    }
    /**
     * expose `froala` binding handler methods
     */
    ko.bindingHandlers.froala = {
        init: init,
        update: update
    };
})();
